import { render, staticRenderFns } from "./CostReviewList.vue?vue&type=template&id=5869506a&scoped=true&"
import script from "./CostReviewList.vue?vue&type=script&lang=js&"
export * from "./CostReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869506a",
  null
  
)

export default component.exports